var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex" },
    [
      _c("Sidebar"),
      _vm._v(" "),
      _c("div", { staticClass: "component-container-sidebar" }, [
        _c("h6", { staticClass: "m-3" }, [
          _vm._v(
            "Account ID: " + _vm._s(_vm.creatorInfo.AdAccountId.substring(4))
          ),
        ]),
        _vm._v(" "),
        _c("h6", { staticClass: "ms-3" }, [
          _vm._v("Campaign ID: " + _vm._s(_vm.selectedCampaign.CampaignId)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card mb-3 mt-3" }, [
          _c("div", { staticClass: "card-header" }, [
            _vm._v("\n                Property Listing\n            "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            !_vm.listing
              ? _c("div", [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-5 mb-3" }, [
                      _c(
                        "label",
                        {
                          staticClass: "form-label",
                          attrs: { for: "listingId" },
                        },
                        [_vm._v("Listing ID")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.listingId,
                              expression: "listingId",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            id: "listingId",
                            placeholder: "Enter Listing ID",
                            disabled: _vm.isLoading,
                          },
                          domProps: { value: _vm.listingId },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.listingId = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            style: {
                              cursor: _vm.isLoading ? "wait" : "pointer",
                            },
                            attrs: {
                              type: "button",
                              disabled: _vm.isLoading || !_vm.listingId.trim(),
                            },
                            on: { click: _vm.lookupListing },
                          },
                          [
                            _vm.isLoading
                              ? _c("span", {
                                  staticClass:
                                    "spinner-border spinner-border-sm me-1",
                                  attrs: {
                                    role: "status",
                                    "aria-hidden": "true",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(
                              "\n                                    Look Up\n                                "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("small", { staticClass: "text-muted" }, [
                        _vm._v("Domain: " + _vm._s(_vm.creatorInfo.DomainName)),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.listing
              ? _c("div", [
                  _c("h6", { staticClass: "mb-3" }, [
                    _vm._v("Please confirm the property listing below:"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mb-2" }, [
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("strong", [_vm._v("Address")]),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-0" }, [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.listing.StreetAddress)
                        ),
                        _vm.listing.UnitNumber
                          ? _c("span", [
                              _vm._v(" #" + _vm._s(_vm.listing.UnitNumber)),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-0" }, [
                        _vm._v(
                          _vm._s(_vm.listing.City) +
                            ", " +
                            _vm._s(_vm.listing.State) +
                            " " +
                            _vm._s(_vm.listing.PostalCode)
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("strong", [_vm._v("Status")]),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-0" }, [
                        _vm._v(_vm._s(_vm.listing.Status)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("strong", [_vm._v("Price")]),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-0" }, [
                        _vm._v(
                          _vm._s(
                            _vm.listing.Price != null
                              ? "$" + _vm.listing.Price.toLocaleString()
                              : "N/A"
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mb-2" }, [
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("strong", [_vm._v("MLS #")]),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-0" }, [
                        _vm._v(_vm._s(_vm.listing.MlsNumber || "N/A")),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("strong", [_vm._v("Beds")]),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-0" }, [
                        _vm._v(
                          _vm._s(
                            _vm.listing.Bedrooms != null
                              ? _vm.listing.Bedrooms
                              : "N/A"
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("strong", [_vm._v("Baths")]),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-0" }, [
                        _vm._v(
                          _vm._s(
                            _vm.listing.Bathrooms != null
                              ? _vm.listing.Bathrooms
                              : "N/A"
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("strong", [_vm._v("Sq Ft")]),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-0" }, [
                        _vm._v(
                          _vm._s(
                            _vm.listing.SquareFeet != null
                              ? _vm.listing.SquareFeet.toLocaleString()
                              : "N/A"
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mb-2" }, [
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("strong", [_vm._v("Year Built")]),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-0" }, [
                        _vm._v(
                          _vm._s(
                            _vm.listing.YearBuilt != null
                              ? _vm.listing.YearBuilt
                              : "N/A"
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("strong", [_vm._v("Provided By")]),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-0" }, [
                        _vm._v(_vm._s(_vm.listing.ProvidedBy || "N/A")),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.listing.DetailsUrl
                      ? _c("div", { staticClass: "col-md-6" }, [
                          _c("strong", [_vm._v("Details URL")]),
                          _vm._v(" "),
                          _c("p", { staticClass: "mb-0" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.listing.DetailsUrl,
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                },
                              },
                              [_vm._v(_vm._s(_vm.listing.DetailsUrl))]
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _vm.listing.Notes
                    ? _c("div", { staticClass: "row mb-3" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c("strong", [_vm._v("Notes")]),
                          _vm._v(" "),
                          _c("p", { staticClass: "mb-0" }, [
                            _vm._v(_vm._s(_vm.listing.Notes)),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.listing.PropertyImageLinks &&
                  _vm.listing.PropertyImageLinks.length > 0
                    ? _c("div", { staticClass: "row mb-3" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c("strong", [
                            _vm._v(
                              "Images (" +
                                _vm._s(_vm.listing.PropertyImageLinks.length) +
                                ")"
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex flex-wrap mt-1" },
                            [
                              _vm._l(
                                _vm.listing.PropertyImageLinks.slice(0, 4),
                                function (imgUrl, index) {
                                  return _c("img", {
                                    key: index,
                                    staticClass: "me-2 mb-2",
                                    staticStyle: {
                                      height: "80px",
                                      width: "120px",
                                      "object-fit": "cover",
                                      "border-radius": "4px",
                                    },
                                    attrs: {
                                      src: imgUrl,
                                      alt: "Property image",
                                    },
                                  })
                                }
                              ),
                              _vm._v(" "),
                              _vm.listing.PropertyImageLinks.length > 4
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "align-self-center text-muted",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    +" +
                                          _vm._s(
                                            _vm.listing.PropertyImageLinks
                                              .length - 4
                                          ) +
                                          " more\n                                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-3" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary me-2",
                        attrs: { type: "button" },
                        on: { click: _vm.confirmListing },
                      },
                      [_vm._v("Save & Continue")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: { type: "button" },
                        on: { click: _vm.cancelListing },
                      },
                      [_vm._v("Cancel")]
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _vm.displayError
          ? _c(
              "div",
              { staticClass: "alert alert-danger", attrs: { role: "alert" } },
              [
                _vm._v(
                  "\n            " + _vm._s(_vm.errorMessage) + "\n        "
                ),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }